import { Update, PasswordRecovery, Profile } from './Children';

// TODO: Add scopes
export const ProfileConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'profileGroup',
      path: 'myself',
      children: [
        {
          id: 'profile.myself',
          path: '',
          element: <Profile />,
        },
        {
          id: 'profile.myself.update',
          path: 'update/:id?',
          element: <Update />,
        },
        {
          id: 'profile.myself.passwordRecovery',
          path: 'recovery/:id?',
          element: <PasswordRecovery />,
        },
      ],
    },
  ],
};
